import React, { useContext } from 'react';
import { isMobileLandscape } from 'react-device-detect';
import TournamentCasinoDetailsParams from './TournamentCasinoDetailsParams';
import TournamentButtons from '../TournamentButtons';
import useTournamentData from './hooks/useTournamentData';
import { getTournamentBuyinInfo } from '../helpers/getTournamentBuyinInfo';

const TournamentCasinoDetailsMobile = ({ data, onPlay, onRegister, onUnregister, onLobby, onClickMobile, onClick }) => {
  const { startsAt, game, buyIn, thumbnail, currency, duration } = useTournamentData(data);
  const { tournamentGames: [tournament], tournamentName, buyIn: {buyin:isFreeroll }} = data;
  const {chipValue} = getTournamentBuyinInfo(data);

  return (
    <div className='tournaments-details'>
      <div className="tournaments-details__header" onClick={() => onClick(data)}>
        <div className="tournaments-details__header-left">
          <span className="tournaments-details__tournament-name">{tournamentName}</span>
          <span className="tournaments-details__tournament-date-enrolled">{`May 12 22:12 | Enrolled: ${data.enrolled}`}</span>
        </div>
        <div className="tournaments-details__header-right">
          <span className="tournaments-details__tournament-type">{data.tournamentType}</span>
          {isFreeroll ?
            <div className="tournaments-details__tournament-buyin-wrapper">
              <span className="tournaments-details__tournament-buyin">Buy In։</span>
              {chipValue()}
            </div> : ''}
        </div>
      </div>
      <div className="tournaments-details__body" >
        <div className="tournaments-details__image-wrapper">
          <img src={thumbnail} alt="Tournament Image"/>
        </div>
        <div className="tournaments-details__more-info-wrapper">
          <div className="tournaments-details__more-info-left">
            <div className="tournaments-details__more-info">
              <span className="tournaments-details__more-info-label">Start:</span>
              <span className="tournaments-details__more-info-value">{data.tournamentType}</span>
            </div>
            <div className="tournaments-details__more-info">
              <span className="tournaments-details__more-info-label">Minimum players:</span>
              <span className="tournaments-details__more-info-value">{data.minPlayersCount}</span>
            </div>
            {isFreeroll  ?
                <div className="tournaments-details__more-info">
                  <span className="tournaments-details__more-info-label">Buy-In:</span>
                  <div className="tournaments-details__more-info-value">
                    {chipValue()}
                  </div>
                </div> : ''}
            <div className="tournaments-details__more-info">
                <span className="tournaments-details__more-info-label">Duration:</span>
                <span className="tournaments-details__more-info-value">{duration}</span>
              </div>
          </div>
          <div className="tournaments-details__more-info-right">
              <div className="tournaments-details__more-info">
                <span className="tournaments-details__more-info-label">Max # of Players:</span>
                <span className="tournaments-details__more-info-value">{data.maxPlayersCount}</span>
              </div>
              <div className="tournaments-details__more-info">
                <span className="tournaments-details__more-info-label">Spins:</span>
                <span className="tournaments-details__more-info-value">{data.numberOfSpins}</span>
              </div>
              <div className="tournaments-details__more-info">
                <span className="tournaments-details__more-info-label">Bet amount:</span>
                <span className="tournaments-details__more-info-value">{data.minBet}</span>
              </div>
          </div>
        </div>

        <TournamentButtons
          tournament={data}
          onLobby={() => onLobby(data)}
          onRegister={() => onRegister(data)}
          onUnregister={() => onUnregister(data)}
          onResume={() => onPlay(data)}
        />
      </div>
    </div>
  );
}

export default TournamentCasinoDetailsMobile;